import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App/index';
import './assets/scss/style.scss';
import config from './config';
import * as serviceWorker from './serviceWorker';
import { store } from './store/store';
import ErrorBoundary from './App/components/ErrorBoundary';
import {RealtimeProvider} from './realtime/RealtimeProvider';
import { ThemeProvider } from '@mui/material/styles';
import GlobalStyles from '@mui/material/GlobalStyles';
import { muiTheme, inputAutofillStyles } from './styles/muiTheme';
// import * as Sentry from '@sentry/react';

const queryClient = new QueryClient();

const isProd = process.env.NODE_ENV === 'production';

// Sentry.init({
//   dsn: 'https://2732bc0f732f51bfbe69b8c4af3441d6@o4506629736300544.ingest.sentry.io/4506629747703808',
//   integrations: [
//     new Sentry.BrowserTracing({
//       // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//       tracePropagationTargets: [/^https:\/\/fdc\.fastclinic\.co\.id/],
//     }),
//     new Sentry.Replay({
//       maskAllText: false,
//       blockAllMedia: false,
//     }),
//   ],
//   // Performance Monitoring
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
//   enabled: isProd,
// });

const app = (
  <React.StrictMode>
    <ThemeProvider theme={muiTheme}>
      <GlobalStyles styles={inputAutofillStyles} />
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <RealtimeProvider>
            <BrowserRouter basename={config.basename}>
              <ErrorBoundary>
                <App />
              </ErrorBoundary>
            </BrowserRouter>
          </RealtimeProvider>
          {!isProd && <ReactQueryDevtools initialIsOpen={false} />}
        </QueryClientProvider>
      </Provider>
    </ThemeProvider>
  </React.StrictMode>
);
ReactDOM.render(app, document.getElementById('root'));
serviceWorker.unregister();
